import Toastify from "toastify-js";

export type ToastVariant = "success" | "error";
export type ToastPosition = "center" | "left" | "right";
export type ToastGravity = "top" | "bottom";

export interface ToastOptions {
  variant: ToastVariant;
  message: string;
  max?: number;
  position?: ToastPosition;
  duration?: number;
  gravity?: ToastGravity;
  style?: { [cssRule: string]: string };
  offset?: {
    x?: number | string;
    y?: number | string;
  };
}

const MAX_TOASTS = 1;
let activeToasts = 0;

/**
 * Shows a toast notification
 * @param options - Toast configuration options
 * @returns The toast instance or undefined if max toasts reached
 */
const showToast = ({
  variant,
  message,
  max = MAX_TOASTS,
  position = "center",
  duration = 3000,
  gravity = "top",
  style,
  offset,
}: ToastOptions) => {
  if (activeToasts < max) {
    activeToasts++;
    const toastOffset = {
      x: offset?.x ?? 0,
      y: offset?.y ?? 0,
    };
    return Toastify({
      text: message,
      position: position,
      duration: duration,
      gravity: gravity,
      className: `toast toast--${variant}`,
      callback() {
        activeToasts--;
      },
      style,
      offset: toastOffset,
    }).showToast();
  }
  return undefined;
};

export default showToast;
